export default "__VITE_ASSET__6cd2ed4b__"